import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Silo {
  static getSilos () {
    const axios = getAxiosInstance()
    const promise = axios.get(`silo?r=` +
    `{"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateSilo (claveCereal, claveSilo) {
    const axios = getAxiosInstance()
    const promise = axios.put(`silo`,
      `{"valores": {"cereal": "${claveCereal}"}, 
    "clave": {"nombre_corto": "${claveSilo}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getSilosValidosVolcadora (claveVolcadora) {
    const axios = getAxiosInstance()
    const promise = axios.get(`silos_validos_volcadora?r=` +
    `{"clave":{"habilitado": "${true}", "volcadora": "${claveVolcadora}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default Silo
